'use client';
import styles from './CategorySelected.module.scss';
import useFilter, { pathToParams } from '@/grandus-utils/hooks/useFilter';
import { replaceKeyForUrlTitle } from '@/grandus-lib/utils/filter';

import { flatMap } from 'lodash';
import { startTransition } from 'react';
import isFunction from 'lodash/isFunction';
import { useSearchParams } from 'next/navigation';
import { getFilterUrl } from '@/utils/filter';
import Link from 'next/link';
import SelectedParameters from '@/app/components/category/products/activeFilter/elements/SelectedParameters';

const CategorySelected = ({
                         isDesktop = false,
                         filterParams,
                         setFilterParams,
                       }) => {
  const flatParameters = flatMap(filterParams?.parameters, (value, key) => [key, encodeURIComponent(value)]);
  const params = { ...filterParams, parameters: flatParameters };
  const { filter } = useFilter({
    category: filterParams?.category,
    search: filterParams?.search,
    parameters: params?.parameters,
  });
  const searchParams = useSearchParams();

  const productsCount = filter?.productsCount;

  const category = filterParams?.category;
  const parameters = filter?.parameters;
  const selected = filterParams?.parameters;

  const getUrl = (parameterTitle, parameterValue) => {
    const url = getFilterUrl(
      filterParams,
      replaceKeyForUrlTitle(parameterTitle),
      parameterValue ? parameterValue : false,
      true,
    );

    let query = {};
    if (searchParams?.get('pageSize')) {
      query['pageSize'] = searchParams?.get('pageSize');
    }

    if (searchParams?.get('orderBy')) {
      query['orderBy'] = searchParams?.get('orderBy');
    }

    url.query = query;
    return url;
  };
  const pathData = {
    category: category,
    selected: selected,
  };

  const handleClick = (parameterTitle, parameterValue) => {
    if (!setFilterParams || !isFunction(setFilterParams)) {
      return;
    }
    const url = getUrl(parameterTitle, parameterValue);
    const newParams = pathToParams(url?.pathname?.replace('/', ''));
    delete newParams['kategoria'];
    startTransition(() => setFilterParams({ ...filterParams, parameters: newParams }));
  };

  return (
    <>
      {/*<div className="flex gap-2">*/}
      {/*  Zobrazuje sa <strong>{productsCount ?? 0} položiek</strong>*/}
      {/*</div>*/}
      <div
        className={`${styles?.filters} ${isDesktop ? styles?.desktopWrap : ''}`}
      >
        <div className={styles?.values}>
          <SelectedParameters
            href={getUrl}
            handleClick={handleClick}
            parameters={filter?.selected?.parameters}
          />
        </div>
        {filter?.selected?.parameters ?
          <Link
            className={styles?.clearAll}
            scroll={false}
            href={getUrl()?.pathname}
            onClick={() => handleClick()}
          >
            Zrušiť filtre
          </Link>
          : null
        }
      </div>
    </>
  );
};
export default CategorySelected;
